export interface LaunchIVA
{
    type: "LAUNCH_IVA";
}

export interface SetLaunchParameters
{
    type: "SET_LAUNCH_PARAMETERS";
    payload: {
        launchPointName: string;
        launchParameter: string;
        launchType: string;
    };
}

export interface SetAccessKey
{
    type: "SET_ACCESS_KEY";
    payload: {
        accessKey: string;
    };
}

export interface SetUserMetadata
{
    type: "SET_USER_METADATA";
    payload: {
        userMetadata: Record<string, unknown>;
    };
}

export interface SetLanguage
{
    type: "SET_LANGUAGE";
    payload: {
        language: string;
    };
}

export interface SetCustomSessionId
{
    type: "SET_CUSTOM_SESSION_ID";
    customSid: string;
}


export type LaunchActionTypes = LaunchIVA | SetLaunchParameters | SetAccessKey | SetUserMetadata | SetLanguage | SetCustomSessionId;

export function LaunchIva(): LaunchActionTypes
{
    return {
        type: "LAUNCH_IVA",
    };
}

export function PrepareLaunchParameters(launchPointName: string, launchParameter: string, launchType: string): LaunchActionTypes
{
    return {
        type: "SET_LAUNCH_PARAMETERS",
        payload: {
            launchPointName,
            launchParameter,
            launchType,
        },
    };
}

export function SetCustomSessionId(customSid: string)
{
    return {
        type: "SET_CUSTOM_SESSION_ID",
        customSid,
    };
}





// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/launch-message-processor/src/actions/Actions.ts